import { render, staticRenderFns } from "./OutpatientPhysician.vue?vue&type=template&id=39569c30&scoped=true"
import script from "./OutpatientPhysician.vue?vue&type=script&lang=js"
export * from "./OutpatientPhysician.vue?vue&type=script&lang=js"
import style0 from "./OutpatientPhysician.vue?vue&type=style&index=0&id=39569c30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39569c30",
  null
  
)

export default component.exports